module.exports = __webpack_public_path__ + "img/hero_bg_desktop.f44fe95.jpg";